import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { ConfigService } from '../config/config.service';

/**
 * Returns a CanActivateFn that requires the principal to carry `role`.
 * Redirects to `/forbidden` otherwise.
 *
 * Roles are sourced from the ConfigService (loaded by APP_INITIALIZER from
 * GET /v1/config), which derives them from the validated JWT.
 */
export function roleGuard(
  role: string,
): (
  _route?: ActivatedRouteSnapshot,
  _state?: RouterStateSnapshot,
) => boolean | UrlTree {
  const guard = (
    _route?: ActivatedRouteSnapshot,
    _state?: RouterStateSnapshot,
  ): boolean | UrlTree => {
    const config = inject(ConfigService);
    if (config.hasRole(role)) {
      return true;
    }
    const router = inject(Router);
    return router.parseUrl('/forbidden');
  };
  // Compile-time check that the returned function is a valid CanActivateFn.
  guard satisfies CanActivateFn;
  return guard;
}
